import styled from 'styled-components'
import GlobalContainer from '../../../../global/globalContainer'

export const NewsroomTeaserContainer = styled(GlobalContainer)`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-column-gap: 24px;
  .listings__featured-listing.listings__featured-listing {
    margin-right: 0;
    border-top: 1px solid ${p => p.theme.webMktPalette.grayNeutral[30]};
  }

  ${p => p.theme.breakpoints.down('sm')} {
    display: block;
  }
`

export const NewsroomPostContainer = styled.div`
  width: 100%;
  background: ${p => p.theme.webMktPalette.background.gray};
  position: relative;

  // override content block styles
  [data-cy='ContentBlock'] > div {
    padding: 0;
  }

  .NewsroomPost__Body-Container .ContentBlock__Inner-Container {
    padding-top: 48px;
  }

  h1 {
    position: relative;
    z-index: 1;
  }

  .NewsroomPost__Body a {
    color: ${p => p.theme.webMktPalette.text.actionLight};
  }

  ol {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .NewsroomPost__Post-Container {
    display: flex;
    justify-content: center;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
  }

  .NewsroomPost__Post-Container div {
    padding-left: 0;
    padding-right: 0;
  }

  .NewsroomPost__SocialMedia-Container {
    height: 100%;
    display: flex;
    margin-bottom: 34px;
    flex-direction: column;
    position: sticky;
    top: 120px;
  }

  .NewsroomPost__SocialMedia-Item {
    display: flex;
    flex-direction: column;
    width: 24px;
    height: 24px;
    margin-left: -126px;
    margin-right: 0;
    margin-bottom: 32px;
    top: 120px;
  }

  .NewsroomPost__SocialMedia-Item svg:hover {
    fill: ${p => p.theme.webMktPalette.icon.blueLight};
  }

  .NewsroomPost__Body-Container {
    max-width: 586px;
    width: 100%;
  }

  .NewsroomPost__Body > img {
    margin: 32px 0;
  }

  .NewsroomPost__Body div > img {
    max-height: 632px;
  }

  .NewsroomPost__Body > *:last-child {
    margin-bottom: 0;
  }

  .NewsroomPost__Body > p {
    word-wrap: break-word;
    margin-top: 0;
    margin-bottom: 24px;
  }

  .NewsroomPost__Body blockquote {
    background-color: ${p => p.theme.webMktPalette.background.white};
    position: relative;
    margin: 80px 0 60px 0;
    border-left: 0;
    padding: 48px;
    box-sizing: border-box;

    ${p => p.theme.breakpoints.down('xs')} {
      padding: 48px 24px;
    }
  }

  .NewsroomPost__Body blockquote::before {
    content: '';
    position: absolute;
    top: -30px;
    left: 48px;
    width: 74px;
    height: 56px;
    background-image: url('https://images.ctfassets.net/5965pury2lcm/6D8NmS3Zf7JZLkVIzD0UjL/97aa5dce32ab883531b4697ff3cf531e/heist-blog-blockquote-quotes.svg');
  }

  .NewsroomPost__Body blockquote > p {
    color: ${p => p.theme.webMktPalette.grayCold[65]};
  }

  .NewsroomPost__Body blockquote p:last-child,
  .NewsroomPost__Body blockquote p:last-child span {
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    margin-top: 32px;
  }

  .NewsroomPost__Body blockquote p:first-child {
    font-size: 24px;
    line-height: 36px;
    font-weight: 400;
    letter-spacing: -0.5px;
    ${p => p.theme.breakpoints.down('md')} {
      font-size: 20px;
      line-height: 32px;
    }
    ${p => p.theme.breakpoints.down('sm')} {
      letter-spacing: 0px;
    }
  }

  .NewsroomPost__Body ul {
    list-style: none;
    margin-left: 26px;
    margin-top: 16px;
  }

  .NewsroomPost__Body ul > li:not(:last-of-type) {
    position: relative;
    margin-bottom: 16px;
  }

  .NewsroomPost__Body ul li:before {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${p => p.theme.webMktPalette.orange[50]};
    position: absolute;
    top: 7px;
    left: -26px;
  }

  .NewsroomPost__Body > ol {
    list-style: decimal;
    margin-left: 20px;
    margin-top: 16px;
    margin-bottom: 32px;
  }

  .NewsroomPost__Body > ol > li > * {
    color: ${p => p.theme.webMktPalette.grayCold[65]};
    margin-bottom: 16px;
  }

  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 32px 0;
  }
`
